import {
  FETCH_LIQUIDACIONES_LISTA_SELLERS,
  FETCH_SELLERS_FILTER,
  FETCH_FACTURACIONES,
  FETCH_INTEGRADORES,
  SET_FILTRO_SELLER,
  FETCH_SELLERS,
  FETCH_SELLER,
  EDIT_SELLER,
  FETCH_PROVEEDORES_FILTER,
  LOADING_SELLERS,
  RESET_SELLERS,
  UPDATE_SELLERS_LIST,
  FETCH_PROVINCIAS_LOCALIDADES,
  CLEAR_LOCALIDAD_PROVINCIA,
  FETCH_LOGISTICA_PROPIA,
  SET_LOGISTICA_PROPIA,
  SET_LOGISTICA_CACHE,
  SET_LOGISTICA_DIRTY,
  CLEAR_LOGISTICA_FOR_SELLER
} from './types';
import {
  getSeller,
  fetchSellersApi,
  listSellersParameters,
  getIntegradores,
  getTipoFacturacion,
  getLiquidacionesListaSellers,
  fetchProveedoresApi,
  getProvinciaLocalidadByCodigoPostalApi,
  fetchLogisticaPropiaApi,
  updateLogisticaPropiaApi,
  putEstadoSellerApi
} from "../api/axios";


export const fetchIntegradores = () => async dispatch => {
  let array = getIntegradores();
  let integradores;
  array.then(function (value) {
    integradores = value;

    dispatch({
      type: FETCH_INTEGRADORES,
      payload: integradores
    });
  });
}

export const fetchProveedoresFilter = (params) => async dispatch => {
  let options = [];
  const defaultParams = { Page: 1, PageSize: 10, ...params };
  let req = fetchProveedoresApi(defaultParams);
  req.then((res) => {



    let data = [];
    const responseObj = res.paginationResponseProveedores || res.PaginationResponseProveedores;

    if (responseObj && Array.isArray(responseObj.content)) {
      data = responseObj.content;
    } else if (responseObj && Array.isArray(responseObj.Content)) {
      data = responseObj.Content;
    } else if (res.elementos && Array.isArray(res.elementos)) {
      data = res.elementos;
    } else if (res.Elementos && Array.isArray(res.Elementos)) {
      data = res.Elementos;
    } else if (Array.isArray(res)) {
      data = res;
    }

    if (data.length > 0) {
      options = data.map((proveedor) => {
        const labelText = proveedor.denomin || proveedor.Denomin || proveedor.descripcion || proveedor.Descripcion || "";
        return {
          value: proveedor.codigo || proveedor.Codigo,
          label: labelText.trim()
        };
      });
    }

    dispatch({
      type: FETCH_PROVEEDORES_FILTER,
      payload: options
    });
  }).catch((err) => {
    dispatch({
      type: FETCH_PROVEEDORES_FILTER,
      payload: []
    });
  });
}

export const setFiltroSeller = (filtro) => dispatch => {
  dispatch({
    type: SET_FILTRO_SELLER,
    payload: filtro
  });
}

export const fetchFacturaciones = () => async dispatch => {
  let array = getTipoFacturacion();
  let facturaciones;
  array.then(function (value) {

    facturaciones = value;
    dispatch({
      type: FETCH_FACTURACIONES,
      payload: facturaciones
    });
  });
}

export const fetchSellers = (Descripcion, CantidadPagina, NumeroPagina) => async dispatch => {
  dispatch({
    type: LOADING_SELLERS,
    payload: true
  });

  let array = listSellersParameters(Descripcion, CantidadPagina ?? '0', NumeroPagina ?? '0');

  array.then((sellers) => {
    dispatch({
      type: FETCH_SELLERS,
      payload: sellers
    });

    dispatch({
      type: LOADING_SELLERS,
      payload: false
    });
  });
}

export const fetchSellersFilter = (params) => async dispatch => {
  let req = fetchSellersApi(params);
  req.then((res) => {

    // Map to include both full seller props AND formatted select options
    const mappedSellers = res.paginateSellers.elementos.map((seller) => ({
      ...seller,
      value: seller.codigo,
      label: seller.razonSocial || seller.nombreTienda
    }));

    dispatch({
      type: FETCH_SELLERS_FILTER,
      payload: mappedSellers
    });
  }).catch((err) => {
    dispatch({
      type: FETCH_SELLERS_FILTER,
      payload: []
    });
  });
}

export const fetchSeller = (id) => async dispatch => {

  let seller;
  if (typeof id !== 'undefined') {

    let sellers = getSeller(id);
    sellers.then(function (value) {
      seller = value.paginateSellers.elementos[0];
      dispatch({
        type: FETCH_SELLER,
        payload: seller
      });
    });
  } else {
    seller = {
      codigo: '',
      codigoPostal: '',
      cuit: '',
      domicilio: '',
      email: '',
      emailUsuario: '',
      emailDespacho: '',
      estado: '',
      idEstado: 1,
      integrador: 1,
      localidad: '',
      numeroDomicilio: '',
      provincia: '',
      razonSocial: '',
      telefono: '',
      tipoFacturacion: 1,
      urlPushOrdenes: '',
      sufijo: '',
      idEmpresaEnviopack: 0,
      nombreUsuario: '',
      nombreTienda: '',
      logo: '',
      tiendaActiva: false,
      internacional: false,
      emisionFacturaA: false,
    }

    dispatch({
      type: FETCH_SELLER,
      payload: seller
    });
  }
}

export const editSeller = (seller) => dispatch => {
  dispatch({
    type: EDIT_SELLER,
    payload: seller
  });
}

export const fetchLiquidacionesListaSellers = () => async dispatch => {
  let array = getLiquidacionesListaSellers();
  array.then(function (value) {
    dispatch({
      type: FETCH_LIQUIDACIONES_LISTA_SELLERS,
      payload: value.listaSellersLiquidaciones
    });
  });
}

export const resetSellers = () => async dispatch => {
  dispatch({
    type: RESET_SELLERS,
    payload: []
  })
};

export const updateListSellers = (sellersArray, seller) => async (dispatch) => {
  const elementos = sellersArray?.paginateSellers?.elementos;

  if (!Array.isArray(elementos) || elementos.length === 0) {
    // No hay elementos para actualizar, salir
    return;
  }

  const existe = elementos.some(item =>
    item.codigo === seller.codigo
  );

  if (!existe) {
    dispatch({
      type: 'UPDATE_SELLERS_LIST',
      payload: [], // no hay cambios, no se actualiza
    });
    return;
  }

  const nuevosElementos = elementos.map(item =>
    item.codigo === seller.codigo ? seller : item
  );

  const updatedSellersArray = {
    ...sellersArray,
    paginateSellers: {
      ...sellersArray.paginateSellers,
      elementos: nuevosElementos,
    },
  };

  dispatch({
    type: 'UPDATE_SELLERS_LIST',
    payload: updatedSellersArray,
  });
};

export const changeSellerStatus = (seller, newStatus) => async (dispatch, getState) => {
  const { sellers } = getState().sellers;
  const originalState = JSON.parse(JSON.stringify(sellers));

  // Optimistic update
  const updatedSeller = { ...seller, estado: newStatus };
  dispatch(updateListSellers(sellers, updatedSeller));

  try {
    const request = {
      listRequest: [
        {
          idSeller: seller.codigo,
          idEstado: newStatus === "activo" ? 1 : 2
        }
      ]
    };
    await putEstadoSellerApi(request);
  } catch (error) {
    // Revert on error
    dispatch({
      type: 'UPDATE_SELLERS_LIST',
      payload: originalState,
    });
    throw error;
  }
};

export const fetchProvinciaLocalidadByCodigoPostal = (data) => async (dispatch) => {

  try {
    const res = await getProvinciaLocalidadByCodigoPostalApi(data);

    dispatch({
      type: FETCH_PROVINCIAS_LOCALIDADES,
      payload: res.localidadProvincia
    });
  } catch (error) {
    console.error("Error al obtener provincias/localidades", error);
  }
};

export const clearLocalidadProvincia = () => ({
  type: CLEAR_LOCALIDAD_PROVINCIA
});


export const fetchLogisticaPropia = (idSeller, { force = false } = {}) =>
  async (dispatch, getState) => {
    const cached = getState().sellers.logisticaCache?.[idSeller];

    // ✅ si hay caché, úsala (aunque esté dirty). Evita “pegadas” al cambiar de tab.
    if (!force && cached?.data) {
      dispatch({ type: SET_LOGISTICA_PROPIA, payload: cached.data });
      return cached.data;
    }

    // si no hay caché o pedís force, pegá
    const data = await fetchLogisticaPropiaApi(idSeller);
    dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data, dirty: false } });
    dispatch({ type: SET_LOGISTICA_PROPIA, payload: data });
    return data;
  };



export const updateLogisticaEscalaField =
  ({ idSeller, idEscala, zona, field, value }) =>
    (dispatch, getState) => {
      const lp = getState().sellers.logisticaPropia || { escalas: [] };

      const next = JSON.parse(JSON.stringify(lp));
      const esc = next.escalas.find(e => e.idEscala === idEscala);
      if (!esc) return;

      const parsed = (field === 'costo')
        ? (value === '' ? null : (Number.isFinite(Number(value)) ? Number(value) : null))
        : (field === 'diasEntrega'
          ? (value === '' ? null : (Number.isFinite(parseInt(value, 10)) ? parseInt(value, 10) : null))
          : value);

      esc[zona] = esc[zona] || {};
      esc[zona][field] = parsed;

      // Actualiza la activa para render inmediato
      dispatch({ type: SET_LOGISTICA_PROPIA, payload: next });

      // Marca dirty y guarda en caché bajo la clave CORRECTA (idSeller)
      if (idSeller != null) {
        dispatch({ type: SET_LOGISTICA_DIRTY, payload: { idSeller, dirty: true } });
        dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data: next, dirty: true } });
      }
    };
export const submitLogisticaPropia = ({ idSeller, zonas, bodyFromState }) =>
  async (dispatch) => {
    await updateLogisticaPropiaApi({ idSeller: Number(idSeller), zonas });

    // opcional: o bien forzar un GET fresco…
    // const data = await fetchLogisticaPropiaApi(idSeller);

    // …o confiar en lo que tenés en memoria (bodyFromState) y marcar clean:
    dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data: bodyFromState, dirty: false } });
    dispatch({ type: SET_LOGISTICA_PROPIA, payload: bodyFromState });
    dispatch({ type: SET_LOGISTICA_DIRTY, payload: { idSeller, dirty: false } });
  };

export const clearLogisticaForSeller = (idSeller) => (dispatch) => {
  dispatch({ type: CLEAR_LOGISTICA_FOR_SELLER, payload: { idSeller } });
};


// helpers locales
const ZONES = ['amba', 'interior', 'patagonia'];
const clone = (o) => JSON.parse(JSON.stringify(o));

/**
 * Inicializa lp.zonasUI a partir de escalas/envioGratisZona si aún no existe.
 * No pisa si ya existe.
 */
export const initZonasUI = (idSeller) => (dispatch, getState) => {
  const lp = getState().sellers.logisticaPropia;
  if (!lp) return;

  // si ya existe, no hacemos nada
  if (lp.zonasUI) return;

  const escalas = lp.escalas || [];
  const envioGratisZona = lp.envioGratisZona || {};
  const zonasUI = {};

  ZONES.forEach((z) => {
    const enabled = escalas.some(e => e[z] !== null && typeof e[z] === 'object');
    const envioGratis = !!envioGratisZona[z];
    zonasUI[z] = { enabled, envioGratis };
  });

  const next = { ...lp, zonasUI };

  dispatch({ type: SET_LOGISTICA_PROPIA, payload: next });
  dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data: next, dirty: false } });
};

/**
 * Toggle/Set de switches: enabled / envioGratis
 * Reglas:
 *  - Si deshabilito enabled => envioGratis = false
 *  - No permito marcar envioGratis si enabled está false
 */
export const updateZonaToggle = ({ idSeller, zona, field, value }) => (dispatch, getState) => {
  const lp = getState().sellers.logisticaPropia;
  if (!lp) return;

  const next = clone(lp);
  next.zonasUI = next.zonasUI || {};
  const curr = next.zonasUI[zona] || { enabled: false, envioGratis: false };
  const updated = { ...curr };

  if (field === 'enabled') {
    updated.enabled = (value != null) ? !!value : !curr.enabled;
    if (!updated.enabled) updated.envioGratis = false;
  } else if (field === 'envioGratis') {
    if (!curr.enabled) return; // ignorar si no está habilitada
    updated.envioGratis = (value != null) ? !!value : !curr.envioGratis;
  }

  next.zonasUI[zona] = updated;

  // actualizo activa + cache y marco dirty
  dispatch({ type: SET_LOGISTICA_PROPIA, payload: next });
  if (idSeller != null) {
    dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data: next, dirty: true } });
    dispatch({ type: SET_LOGISTICA_DIRTY, payload: { idSeller, dirty: true } });
  }
};


